import LinkIcon from "@mui/icons-material/Link";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";

import { EventActionTypeEnum } from "~/feature/event/components/ActionButtons/types";

type IconComponent = typeof StarBorderRoundedIcon;

export const iconByActionType: Record<EventActionTypeEnum, IconComponent> = {
  [EventActionTypeEnum.CopyLink]: LinkIcon,
  [EventActionTypeEnum.Share]: ShareOutlinedIcon,
  [EventActionTypeEnum.AddToWatchlist]: StarBorderRoundedIcon,
  [EventActionTypeEnum.RemoveFromWatchlist]: StarRoundedIcon,
};

export const labelByActionType: Record<EventActionTypeEnum, string> = {
  [EventActionTypeEnum.CopyLink]: "Copy link",
  [EventActionTypeEnum.Share]: "Share",
  [EventActionTypeEnum.AddToWatchlist]: "Add to a watchlist",
  [EventActionTypeEnum.RemoveFromWatchlist]: "remove from a watchlist",
};

export const iconColorByActionType: Partial<
  Record<EventActionTypeEnum, "gold">
> = {
  [EventActionTypeEnum.RemoveFromWatchlist]: "gold",
};
